import React, {Component} from "react";
import {map, isEmpty} from "lodash";
import SideBar from "./SideBar";
import Loader from "../../../../../../Common/Component/Loader";
import * as yup from "yup";
import {message} from "antd";

// mapping frequency
const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

// mapping cleaning area
const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

// mapping last clean
const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

// mapping dog count
const dog_count = [{key: '1', value: '1'}, {key: '2', value: '2'}, {key: '3', value: '3'}, {key: '4+', value: '4'}]

class ServiceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      frequency: '',
      areaClean: [],
      add_ons: [],
      propertyType: '',
      lastCleaned: '',
      dogCount: '',
      franchises: {},
      disposalLocation: '',
      cleaningNotes: '',
      is_btn_active: false,
      is_basic_btn_active: false,
      is_extra_pet: false,
      extra_pet: '',
      errors: {},
      loader: false,
      enquiryList: {},
      isLocalValueChanged: false,
      fieldOffice: {},
      otherCleaning: '',
      isOtherCleanArea: false
    }
  }

  componentDidMount = () => {
    console.warn('Add Service', this.props)
    const data = JSON.parse(sessionStorage.getItem('step1'));
    const calcData = JSON.parse(sessionStorage.getItem('calcData'));
    let obj = {
      frequency: data?.frequency || '', add_ons: data?.add_ons || [],
      areaClean: data?.areaClean || [], propertyType: data?.propertyType || '',
      lastCleaned: data?.lastCleaned || '', dogCount: data?.dogCount || '',
      disposalLocation: data?.disposalLocation || '',
      cleaningNotes: data?.cleaningNotes || '',
      extra_pet: data?.extra_pet || '', is_extra_pet: data?.is_extra_pet || false,
      coupon_code: calcData?.coupon_code,
    }
    this.setState({...obj, isLocalValueChanged: true}, () => this.onPriceCalc(true))
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    // get customer detail
    if (Object.keys(nextProps?.customerList?.customer).length > 0
      && JSON.stringify(nextProps?.customerList?.customer) !== JSON.stringify(this.state.customer)) {
      this.setState({ loader: false, customer: nextProps?.customerList?.customer });
    }

    // get service order enquiry
    if (nextProps?.serviceOrderEnquiry && Object.keys(nextProps?.serviceOrderEnquiry?.enquiryList).length > 0
      && JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList) !== JSON.stringify(this.state.enquiryList) && !this.state.isLocalValueChanged && this.props.isEditEnquiry) {
      const enquiry = nextProps?.serviceOrderEnquiry?.enquiryList?.results?.[0];
      const data = JSON.parse(sessionStorage.getItem('step1'));
      const calcData = JSON.parse(sessionStorage.getItem('calcData'));
      let obj = {}
      if (!isEmpty(data)) {
        let claning_area = [...data?.areaClean];
        let other = claning_area?.filter(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' });
        obj = {
          frequency: data?.frequency || '', 
          add_ons: data?.add_ons || [],
          propertyType: data?.propertyType || '',
          lastCleaned: data?.lastCleaned || '', 
          dogCount: data?.dogCount || '',
          disposalLocation: data?.disposalLocation || '',
          cleaningNotes: data?.cleaningNotes || '',
          extra_pet: data?.extra_pet || '', 
          is_extra_pet: data?.is_extra_pet || false, 
          coupon_code: calcData?.coupon_code
        }
        if (other && other.length > 0) {
          claning_area.forEach((item, idx) => {
            if (item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area') {
              claning_area[idx] = ''
            }            
          });
          obj['areaClean'] = [...claning_area];
          obj['otherCleaning'] = other[0];
          this.setState({isOtherCleanArea: true});
        } else {
          obj['areaClean'] = enquiry?.area_to_clean || [];
          obj['otherCleaning'] = '';
        }
      } else {
        console.warn('enquiry', enquiry);
        let claning_area = enquiry && enquiry?.area_to_clean ? [...enquiry?.area_to_clean] : [];
        let other = claning_area && claning_area.length > 0 ? claning_area?.filter(item => { return item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area' }) : [];
        obj = {
          frequency: enquiry?.frequency || '', 
          add_ons: enquiry?.service_add_ons || [],
          propertyType: enquiry?.property_type || '',
          lastCleaned: enquiry?.last_cleaned || '', 
          dogCount: enquiry?.pet_count >= 4 ? '4' : enquiry?.pet_count?.toString(),
          disposalLocation: enquiry?.disposal_location || '',
          cleaningNotes: enquiry?.cleaning_notes || '',
          extra_pet: enquiry?.pet_count >= 4 ? enquiry?.pet_count?.toString() : '', 
          is_extra_pet: enquiry?.pet_count >= 4,
          loader: false, enquiryList: nextProps?.serviceOrderEnquiry?.enquiryList,
          field_office_uuid: enquiry?.field_office_uuid,
          coupon_code: enquiry?.coupon_code
        }
        if (other && other.length > 0) {
          claning_area.forEach((item, idx) => {
            if (item !== 'front yard' && item !== 'back yard' && item !== 'right side' && item !== 'left side' && item !== 'dog run' && item !== 'fenced area') {
              claning_area[idx] = ''
            }            
          });
          obj['areaClean'] = [...claning_area];
          obj['otherCleaning'] = other[0];
          this.setState({isOtherCleanArea: true});
        } else {
          obj['areaClean'] = enquiry?.area_to_clean || [];
          obj['otherCleaning'] = '';
        }
      }
      this.setState({...obj, isLocalValueChanged: false}, () => {this.onPriceCalc(true)})
    }

    // get franchise detail
    if (Object.keys(nextProps?.zipcodeCheck?.fieldOfficeDetail).length > 0
      && JSON.stringify(nextProps?.zipcodeCheck?.fieldOfficeDetail) !== JSON.stringify(this.state.franchises)) {
      this.setState({ loader: false, franchises: nextProps?.zipcodeCheck?.fieldOfficeDetail });
    }

    if (Object.keys(nextProps?.Service?.fieldOffice).length > 0 && JSON.stringify(nextProps?.Service?.fieldOffice) !== JSON.stringify(this.state.fieldOffice)) {
      this.setState({ loader: false, fieldOffice: nextProps?.Service?.fieldOffice });
    }
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    console.log(((!isNaN(value) && reg.test(value)) || value === '' || value === '-'))
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on service detail change
  onTextChange = (e, type) => {
    const calcFields = ['frequency', 'areaClean', 'propertyType', 'lastCleaned', 'dogCount', 'add_ons'];
    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (e.target.name === 'dogCount' && e.target.value === '4') {
      this.setState({is_extra_pet: true})
    } else if(e.target.name === 'dogCount') {
      this.setState({is_extra_pet: false, extra_pet: ''})
    }
    this.setState({ [e?.target?.name]: value, isLocalValueChanged: true }, () => this.onPriceCalc(calcFields.includes(e?.target?.name)))
  }

  // on extra pet change
  onExtraPet = (e) => {
    const value = e.target.value;
    if (parseInt(value) >= 4 || value === '') {
      this.setState({[e?.target?.name]: value, isLocalValueChanged: true}, () => this.onPriceCalc(true))
    }
  }
  
  // on clean area changed
  onCleanAreaChanged = (e, value) => {
    const {areaClean = [], isOtherCleanArea} = this.state;
    const idx = areaClean.indexOf(value);
    if (idx <= -1) {
      areaClean.push(value);
    } else {
      areaClean.splice(idx, 1);
    }
    if (!value) {
      this.setState(s => ({ ...s, isOtherCleanArea: !isOtherCleanArea }))
    }
    this.setState({areaClean, isLocalValueChanged: true},  () => this.onPriceCalc(true))
  }

  // on add ons change
  onAddOnsChange = (e, value, item) => {
    const {add_ons} = this.state;

    const idx = add_ons.findIndex(obj => obj.add_on_uuid === item.uuid)
    if (idx > -1) add_ons.splice(idx, 1)

    if (e.target.checked) {
      add_ons.push({...item, add_on_uuid: item?.uuid, is_recurring: value})
    }
    this.setState({add_ons, isLocalValueChanged: true},  () => this.onPriceCalc(true));
  }

  // validate required field
  validate = () => {
    const {frequency, propertyType, dogCount, is_extra_pet, extra_pet, areaClean, otherCleaning, lastCleaned} = this.state;

    const schema = yup.object().shape({
      frequency: yup.string().required('Frequency is required'),
      propertyType: yup.string().required('Place is required'),
      is_extra_pet: yup.bool(),
      dogCount: yup.string().test('match', 'Please select the number of dogs.', (dogCount) => {
        if (!is_extra_pet) return dogCount
        return true
      }),
      extra_pet: yup.string().test('match', 'Please enter a value between 4 and 99.', (extra_pet) => {
        if (is_extra_pet) return extra_pet
        return true
      }),
      areaClean: areaClean.length === 0 ? yup.string().required('Please select at least one cleaning area') : null,
      otherCleaning: areaClean.indexOf("") > -1 && (otherCleaning === undefined || otherCleaning === '') ? yup.string().required('Please enter the Other cleaning area.') : null,
      lastCleaned: yup.string().required('Please select when the property was last cleaned.'),
    });

    const data = {frequency, propertyType, dogCount, is_extra_pet, extra_pet, areaClean, lastCleaned};

    schema.validate(data, { abortEarly: false }).then(() => {
      this.storeInLocal()
      this.setState({errors: {}}, () =>
        this.props.onTabChange(1)
      )
    }).catch((error) => {
      console.log(error)
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data})
    });
  };

  // on price calc
  onPriceCalc = (isCalcField = false) => {
    this.storeInLocal()
    if (isCalcField) this.props.priceCalc()
  }

  // store data in local storage
  storeInLocal = () => {
    const {
      frequency,
      areaClean,
      propertyType,
      lastCleaned,
      dogCount,
      disposalLocation,
      cleaningNotes,
      add_ons,
      extra_pet,
      is_extra_pet,
      franchises,
      coupon_code,
      otherCleaning
    } = this.state;

    let area_to_clean = [];

    if (areaClean && areaClean.length > 0) {
      area_to_clean = areaClean;
      const idx = area_to_clean.indexOf("");
      
      if (idx > -1) {
        area_to_clean[idx] = otherCleaning;
      }
    }

    sessionStorage.setItem('calcData', JSON.stringify({coupon_code}));
    sessionStorage.setItem('step1', JSON.stringify({
      frequency,
      add_ons,
      areaClean: area_to_clean,
      propertyType,
      lastCleaned,
      dogCount,
      disposalLocation,
      cleaningNotes,
      extra_pet,
      is_extra_pet,
      franchises,
      otherCleaning
    }));
  }

  onCancel = () => {
    this.props.onChangeView(0)
    sessionStorage.removeItem('step1');
    sessionStorage.removeItem('step2');
    sessionStorage.removeItem('calcData');
    sessionStorage.removeItem('pricingCalc');
  }

  render() {
    const {
      frequency,
      areaClean,
      add_ons,
      propertyType,
      lastCleaned,
      dogCount,
      fieldOffice,
      extra_pet,
      is_extra_pet,
      errors,
      loader,
      disposalLocation,
      cleaningNotes,
      otherCleaning,
      isOtherCleanArea
    } = this.state;
    
    return (
      <div className="container">
        {loader && <Loader />}
        <div className="fluid-block">
          <div className="article-block">
            <div style={{"padding": "30px"}}>
              <h3>Base Cleaning Requirements</h3>
              <div className="form-block">
                <div className="frow">
                  <h4>How often do you need your yard cleaned?</h4>
                  <div className="oplist">
                    {map(frequency_data, (item, index) => {
                      return (
                        <div className="inline-checks" key={`frequency${index}`}>
                          <label htmlFor={item?.value} className={`${frequency === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name="frequency" className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'frequency', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                  </div>
                  {errors?.['frequency'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['frequency']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>What’s your place like?</h4>
                  <div className="oplist">
                    {map(property_type, (item, index) => {
                      return (
                        <div className="inline-checks" key={`propertyType${index}`}>
                          <label htmlFor={item?.value} className={`${propertyType === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='propertyType' className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'propertyType', value: item?.value}})}/>
                            <span>{item?.key} <br/> {item?.comment}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['propertyType'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['propertyType']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>How many pups on property?</h4>
                  <div className="oplist">
                    {map(dog_count, (item, index) => {
                      return (
                        <div className="inline-checks" key={`dogCount${index}`}>
                          <label htmlFor={`dogCount${index}`} className={`${dogCount === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={`dogCount${index}`} name='dogCount' className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'dogCount', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {is_extra_pet &&
                  <div className="fitem">
                    <input
                      type='text'
                      name='extra_pet'
                      maxLength={2}
                      minLength={1}
                      value={extra_pet}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onExtraPet(e) }
                      placeholder="Please specify the exact number of dogs" />
                  </div>
                  }
                  {errors?.['dogCount'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['dogCount']}</label> : ''}
                  {errors?.['extra_pet'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['extra_pet']}</label> : ''}
                </div>
                <div className="frow md-label">
                  <h4>When was your yard last cleaned?</h4>
                  <div className="oplist">
                    {map(last_cleaned, (item, index) => {
                      return (
                        <div className="inline-checks" key={`lastCleaned${index}`}>
                          <label htmlFor={item?.value} className={`${lastCleaned === item?.value ? 'active' : ''}`}>
                            <input type="radio" id={item?.value} name='lastCleaned' className="" value={item?.value} onChange={() => this.onTextChange({target: {name: 'lastCleaned', value: item?.value}})}/>
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )
                    })}
                  </div>
                  {errors?.['lastCleaned'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['lastCleaned']}</label> : ''}
                </div>
                <hr/>
                <h3>Customizable the Clean</h3>

                <div className="frow sm-label">
                  <h4 className="flex">Areas to clean <small>1 area included in price, add ${fieldOffice?.additional_cleaning_area_price || 0}/visit for each additional area. </small></h4>
                  <div className="oplist">
                    {map(area_clean, (item, index) => {
                      const isIncluded = areaClean?.includes(item?.value)
                      return (
                        <div className="inline-checks" key={`areaClean${index}`}>
                          <label htmlFor={item?.value} className={isIncluded ? "active" : ''}>
                            <input
                              className=""
                              type="checkbox"
                              id={item?.value}
                              name={item?.value}
                              value={item?.value}
                              onChange={(e) => this.onCleanAreaChanged(e, item?.value)}
                            />
                            <span>{item?.key}</span>
                          </label>
                        </div>
                      )}
                    )}
                    {isOtherCleanArea && <div className="from-group w-100">
                      <div className="fitem">
                        <input 
                          type="text" 
                          id="bi_monthly1" 
                          name="bi_monthly" 
                          placeholder="Additional other areas to clean"
                          value={otherCleaning}
                          onChange={(e) => {
                            this.setState({otherCleaning: e.target.value});
                          }}
                        />
                      </div>
                    </div>}
                  </div>
                </div>
                {errors?.['areaClean'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['areaClean']}</label> : ''}
                {errors?.['otherCleaning'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['otherCleaning']}</label> : ''}
              </div>
              <div className="form-block flex flex-start flex-wrap">
                <h4 className="flex">Additional Services</h4>
                <div className="frow sm-label flex flex-start flex-wrap">

                  {
                    map(fieldOffice?.add_on, (item, index) => {
                      const currentAddOn = add_ons?.filter(obj => obj.add_on_uuid === item.uuid)
                      const eachVisit = !isEmpty(currentAddOn) ? currentAddOn?.[0]?.is_recurring : false;
                      const firstVisit = !isEmpty(currentAddOn) ? !currentAddOn?.[0]?.is_recurring : false;

                      if (item?.is_active) {
                        return (
                          <div className="oplist flex flex-column selected" key={`addons${index}`}>
                            <h5>{item?.name} <br/> +${item?.cost_per_visit} per visit</h5>
                            <div className="flex">
                              <div className="inline-checks">
                                <label htmlFor={`firstvisit${index}`} className={firstVisit ? "active" : '' }>
                                  <input type="checkbox" id={`firstvisit${index}`} name="is_recurring" className="" value={!item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, false, item)} />
                                  <span>First Visit</span>
                                </label>
                              </div>
                              <div className="inline-checks">
                                <label htmlFor={`eachvisit${index}`}  className={eachVisit ? "active" : '' }>
                                  <input type="checkbox" id={`eachvisit${index}`} name="is_recurring" className="" value={item?.is_recurring}
                                    onChange={(e) => this.onAddOnsChange(e, true, item)}/>
                                  <span>Each Visit</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })
                  }
                </div>
              </div>
              <div className="form-block">
                <div className="frow">
                  <h4>Scooped waste disposal location</h4>
                  <p>Our standard policy is to double bag the scooped waste, tie it securely to contain odor, and place it in your garbage can. Please let us know where the garbage can is located or if you’d like the bagged waste placed elsewhere.</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Scooped Waste Dispotal Location" name="disposalLocation" value={disposalLocation} onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
                <div className="frow">
                  <h4>Cleaning Notes</h4>
                  <p>Any special instructions about your property that we should know? (e.g. gate code, yard aces etc.)</p>
                  <div className="form-group">
                    <div className="fitem">
                      <input type="text" placeholder="Additional cleaning notes" name="cleaningNotes" value={cleaningNotes} onChange={(e) => this.onTextChange(e)}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <SideBar
            coupon_code={this.state.coupon_code}
            setCouponCode={(value) => this.setState({coupon_code: value})}
            // reducers
            PricingCalc={this.props.PricingCalc}
            serviceOrderEnquiry={this.props.serviceOrderEnquiry}
            customerId={this.props.customerId}
            //
            priceCalc={this.props.priceCalc}
            frequency={frequency}
            currentTab={this.props.currentTab}
            getServiceOrder={this.props.getServiceOrder}
            getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
          />
        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          <button className={`btn btn-warning`} onClick={() => this.validate()}>Next: GO TO BILLING</button>
        </div>
      </div>
    )
  }
}

export default ServiceInfo;